import { Injectable } from '@angular/core';

import { DateService } from './date.service';

export const enum TimestampType {
    None,
    JustNow,
    LessThanOneHour,
    Today,
    Yesterday,
    ThisWeek,
    ThisYear,
    FullDate,
    InLessThanOneHour,
    InMinutes
}

@Injectable({
    providedIn: 'root'
})
export class TimestampFormatService {

    constructor(
        private readonly dateService: DateService
    ) {
    }

    public getTimestampType(date: Date): TimestampType {
        const timespan = this.dateService.timespanInSeconds(date);

        const midnight = this.dateService.getLocalMidnight();
        const yesterday = this.dateService.addDays(midnight, -1);
        const startOfWeek = this.dateService.addDays(midnight, -6);
        const startOfYear = this.dateService.getStartOfYear();

        if (timespan >= -60 * 55 && timespan < -60 * 1) { /* between 55 min and 1 min in future */
            return TimestampType.InMinutes;
        } else if (timespan < 0 ) {
            return TimestampType.None;
        } else if (timespan < 60 * 2) { /* less than 2 minutes */
            return TimestampType.JustNow;
        } else if (timespan < 3600) {   /* 2 minutes - 1 hour */
            return TimestampType.LessThanOneHour;
        } else if (date >= midnight) { /* Today */
            return TimestampType.Today;
        } else if (date >= yesterday) { /* Yesterday */
            return TimestampType.Yesterday;
        } else if (date >= startOfWeek) { /* In current week */
            return TimestampType.ThisWeek;
        } else if (date >= startOfYear) { /* In current year */
            return TimestampType.ThisYear;
        } else {
            return TimestampType.FullDate;
        }
    }
}
